// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Svg_gdpr from '../../img/gdpr.svg';
import Svg_ccpa from '../../img/ccpa.svg';
import styles from './security.module.less';

export const Scale_with_security = ()=>{
    const {theme} = useContext(Settings_context);
    return <section className={styles.security}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.text}>
            <p className={theme.H2}>Scale with Security</p>
            <p className={cn(theme.p16, theme.med)}>Oculus is audited and
              certified by industry leading Third Party standards. Read more
              on our <Link to="/legal/privacy">Privacy Policy</Link>.</p>
          </div>
          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.icon}><Svg_gdpr/></div>
              <div className={styles.title}>
                <p>GDPR</p>
                <p>COMPLIANT</p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.icon}><Svg_ccpa/></div>
              <div className={styles.title}>
                <p>CCPA</p>
                <p>COMPLIANT</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
